/**
 * Display helpers for leftover / incomplete trucking legs.
 * Dispatch can list a pending leg that was never attached to Job.legs and has
 * no order number or route.
 */

/**
 * @param {object|null|undefined} leg
 * @returns {string}
 */
export function getLegOrderNumberLabel(leg) {
  const value = leg?.orderNumber;
  if (value == null) return "Empty leg";
  const text = String(value).trim();
  return text || "Empty leg";
}

/**
 * Prefer GET /legs?jobId= so unattached pending legs appear on job show.
 *
 * @param {object|null|undefined} job
 * @param {Array<object>|null|undefined} fetchedLegs
 * @returns {object|null|undefined}
 */
export function mergeJobLegsWithFetched(job, fetchedLegs) {
  if (!job) return job;
  if (!Array.isArray(fetchedLegs) || fetchedLegs.length === 0) return job;
  return { ...job, legs: fetchedLegs };
}
